import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './auth/AdminProtectedRoute';

// Sesiones
import EvaluacionList from './pages/EvaluacionList';
import VideoList from './pages/VideoList';
import VideoAsignacion from './pages/VideoAsignacion';

// Temporada


// User & Disty
import UserList from './pages/UserList';
import Users from './components/Users';
import Experts from './components/Experts';
import ConfigDistribuidor from './pages/ConfigDistribuidor';

// Personalizar Sitio
import CarruselList from './pages/CarruselList';
import PopupList from './pages/PopupList';

import Home from './pages/Home';
import Login from './pages/Login';

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />

            {/* Protected */}
            <Route path="/" element={<AdminProtectedRoute><Home /></AdminProtectedRoute>} />

            {/* Temporada */}

            {/* Sesiones */}
            <Route path="/asignacion-sesiones" element={<AdminProtectedRoute><VideoAsignacion /></AdminProtectedRoute>} />
            <Route path="/listado-evaluaciones" element={<AdminProtectedRoute><EvaluacionList /></AdminProtectedRoute>} />
            <Route path="/listado-videos" element={<AdminProtectedRoute><VideoList /></AdminProtectedRoute>} />
            

            {/* User & Disty */}
            <Route path="/config-distribuidor" element={<AdminProtectedRoute><ConfigDistribuidor /></AdminProtectedRoute>} />
            <Route path="/listado" element={<AdminProtectedRoute><UserList /></AdminProtectedRoute>}>
              <Route path="usuarios" element={<Users />} />
              <Route path="expertos" element={<Experts />} />
            </Route>

            {/* Personalizar Sitio */}
            <Route path="/listado-carrusel" element={<AdminProtectedRoute><CarruselList /></AdminProtectedRoute>} />
            <Route path="/listado-pop-ups" element={<AdminProtectedRoute><PopupList /></AdminProtectedRoute>} />


          </Routes>
        </BrowserRouter>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
